export default __webpack_public_path__ + "static/media/play-store.5cb3ffec.svg";